import { IconButton, Tooltip } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const LanguagePicker: FC = () => {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language || 'en';
  const isSpanish = currentLanguage.startsWith('es');

  const toggleLanguage = (): void => {
    const newLanguage = isSpanish ? 'en' : 'es';
    void i18n.changeLanguage(newLanguage);
  };

  return (
    <Tooltip title={isSpanish ? 'Switch to English' : 'Cambiar a Español'}>
      <IconButton onClick={toggleLanguage} sx={{ marginRight: 2 }}>
        <img
          src={isSpanish ? '/images/usa.png' : '/images/spain.png'}
          alt={isSpanish ? 'English' : 'Español'}
          style={{ width: 28, height: 20, borderRadius: 2 }}
        />
      </IconButton>
    </Tooltip>
  );
};
